'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { OperatorDomain } from '@alien-platform/bo-sdk';
import { CircularProgress, Divider } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { DataFetchResponse } from '@/types/general';
import { DetailsTable } from '@/components/core/details-table';
import { DetailsTableItem } from '@/components/core/details-table-item';

export function DetailsTab(): React.JSX.Element {
  const { DOMAIN_DETAILS } = useAppSelector(getDrawerContent);
  const [domainData, setDomainData] = React.useState<OperatorDomain>();

  const fetchDomainData = async (): Promise<void> => {
    try {
      const response = await fetch(`/api/devops/domains/list?opId=${DOMAIN_DETAILS?.opId}`, {
        method: 'post',
        body: JSON.stringify({ domainName: DOMAIN_DETAILS?.domainName, opId: DOMAIN_DETAILS?.opId }),
      });
      const result: DataFetchResponse<OperatorDomain> = await response.json();
      if (response.ok && result.success) {
        setDomainData(result.data);
      }
    } catch (e) {
      // empty block
    }
  };

  React.useEffect(() => {
    void fetchDomainData();
  }, []);

  return (
    <Stack direction="column">
      {!domainData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <></>
        // <DetailsTable
        //   divider={<Divider />}
        //   sx={{ '--PropertyItem-padding': '16px' }}
        //   data={domainData}
        //   paths={['domainName', 'opId', 'opTitle', 'cfZoneNameServers']}
        // >
        //   {(
        //     Object.entries(domainData).map(([key, value]) => ({ key, value })) satisfies {
        //       key: string;
        //       value: React.ReactNode;
        //     }[]
        //   ).map(
        //     (item): React.JSX.Element => (
        //       <DetailsTableItem key={item.key} name={item.key} value={item.value} />
        //     )
        //   )}
        // </DetailsTable>
      )}
    </Stack>
  );
}
